export default "__VITE_ASSET__DSB0783H__"